import React, { useState, useEffect } from "react";

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Form,
    Container,
    Row,
    Col,
    Spinner
} from "reactstrap";
// core components
import Header from "../../../../components/Headers/BasicHeader";
import { useNavigate, useParams } from "react-router-dom";
import { getPlan, postPlan, putPlan } from "network/ApiAxios";
import AccountInformation from "./AccountInformation";
import PlanInformation from "./PlanInformation";
import ManagementInformation from './ManagementInformation';
import BasicModal from '../../../../components/Modals/BasicModal'
import {validateData} from '../../../../utils/views/pages/Dynamics'

const Profile = (props) => {

    const navigate = useNavigate();
    const params = useParams()
    const [plan, setPlan] = useState({});
    const formDisabled = (props.action == "view")
    const [showModal, setShowModal] = useState(false)
    const [modalMessage, setModalMessage] = useState("")
    const [modalTitle, setModalTitle] = useState()
    const [modalGoTo, setModalGoTo] = useState()
    const [isLoading, setisLoading] = useState(false)
    const validations = {
        name: '',
        app: '',
        price: '',
        licensesLimit: '',
        periodicity: '',
    }

    useEffect(() => {
        
        const runAsync = async () => {
            const response = await getPlan(params.id);
            const { data } = response;

            if (data.success) {
                setPlan(data.plan);
            } else {
                setModalTitle("Error")
                setModalMessage(data.msg)
                setShowModal(true)
            }
        }

        if (props.action != "create") {
            runAsync();
        }

    }, []);

    let sendData = () => {
        const runAsync = async () => {

            let response = ''
            
            if(props.action=="create"){
                response = await postPlan(plan);
            }else if(props.action=="edit"){
                plan.id = params.id                
                response = await putPlan(plan);
            }
            
            const { data } = response;
            
            if (data.success) {
                setModalTitle("Information")
                setModalMessage(data.msg)
                setShowModal(true)
                setModalGoTo('/admin/plans')
            } else {
                setModalTitle("Error")
                setModalMessage(data.msg)
                setShowModal(true)
            }

            setisLoading(false);
        }
        
        runAsync();
    }
    
    let mountAccountInformation = () => {

        if (props.action == "create")
            return <></>
        else {
            return (
                <AccountInformation
                    plan={plan}
                    formDisabled={true} />
            )
        }
    }   

    let handleSubmit = () => {
        if (validateData(validations, plan, setModalTitle, setModalMessage, setShowModal)) {            
            //console.log(plan)
            setisLoading(true);
            sendData()
        }
    }

    return (
        <>
            <Header />
            {/* Page content */}
            {/*console.log(props.action)*/}
            {/*console.log(params.id)*/}

            <Container className="border-0 pb-0 pt-0 pt-md-3" fluid>
                <Row>

                    <Col className="order-xl-1" >
                        <Card className=" shadow">
                            <CardHeader className="bg-white border-0">
                                <Row className="align-items-center">
                                    <Col xs="8" className="text-left">
                                        <Button onClick={() => navigate('/admin/plans')}
                                            className="btn-back" type="button">

                                            <span className="btn-inner--icon">
                                                <i className="ni ni-bold-left" />
                                            </span>

                                            <span className="btn-inner--text h3 mb-0">Plan's Profile</span>

                                        </Button>
                                        
                                    </Col>

                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Form>

                                    <PlanInformation
                                        plan={plan}
                                        formDisabled={formDisabled || isLoading}
                                        setPlan={setPlan}
                                        validations={validations} />

                                    <hr className="my-4" />

                                    <ManagementInformation
                                        plan={plan}
                                        formDisabled={formDisabled || isLoading}
                                        setPlan={setPlan}
                                        validations={validations} />

                                    {mountAccountInformation()}

                                    <hr className="my-4" />

                                    <Row className="align-items-left">
                                        <Col className="text-left" xs="4">

                                            <Button onClick={() => navigate('/admin/plans')}
                                                className="btn-icon btn-3" color="primary" type="button">

                                                <span className="btn-inner--icon">
                                                    <i className="ni ni-bold-left" />
                                                </span>

                                                <span className="btn-inner--text">Back</span>

                                            </Button>

                                        </Col>

                                        {
                                            function () {
                                                return (

                                                    props.action == "view" ? "" :

                                                        <Col className="text-right" xs="8">
                                                            <Button onClick={handleSubmit}
                                                                className="btn-icon btn-3" color="success" type="button"
                                                                disabled={isLoading}
                                                            >
                                                                
                                                                
                                                                {isLoading ? (

                                                                    <Spinner size="sm" className="me-2 mx-1" />
                                                                ) : 
                                                                
                                                                (
                                                                    <>
                                                                        <span className="btn-inner--icon">
                                                                            <i className="ni ni-check-bold" />
                                                                        </span>

                                                                        <span className="btn-inner--text">Confirm</span>
                                                                    </>
                                                                )}

                                                                
                                                            </Button>
                                                        </Col>
                                                )
                                            }()
                                        }

                                    </Row>

                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <BasicModal
                title={modalTitle}
                message={modalMessage}
                showModal={showModal}
                setShowModal={setShowModal}
                handleGoTo={modalGoTo} />
        </>
    );
}

export default Profile;
